export const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId)
  if (!element) return
  // Scroll the window directly (not scrollIntoView): `body{overflow-x}` can make
  // body a scroll container, which breaks scrollIntoView. Offset for the fixed navbar.
  const top = element.getBoundingClientRect().top + window.scrollY - 72
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
}

export const formatNumber = (num) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M'
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K'
  }
  return num.toString()
}

export const debounce = (func, wait) => {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export const throttle = (func, limit) => {
  let inThrottle
  return function(...args) {
    if (!inThrottle) {
      func.apply(this, args)
      inThrottle = true
      setTimeout(() => inThrottle = false, limit)
    }
  }
}

export const getRandomInRange = (min, max) => {
  return Math.random() * (max - min) + min
}

export const lerp = (start, end, factor) => {
  return start * (1 - factor) + end * factor
}

export const clamp = (value, min, max) => {
  return Math.min(Math.max(value, min), max)
}

export const isMobile = () => {
  return window.innerWidth < 768
}

export const isTablet = () => {
  return window.innerWidth >= 768 && window.innerWidth < 1024
}

export const isDesktop = () => {
  return window.innerWidth >= 1024
}